<template>
    <mymodal ref="modal" title="Настройка подбора объектов-аналогов" ok="Применить" :reset="reset" :submit="submit" :ok_disabled="!check_roles([ 'model' ])" :check="check">

        <b-row class="align-items-center">
            <b-col><strong>Периодичность</strong></b-col>
            <b-col>
                <strong>
                    Количество периодов, для которых указана скорректированная цена арендной платы
                </strong>
            </b-col>
        </b-row>
        
        <template v-if="data">
            <b-row v-for="option in options" :key="option" class="mt-2 align-items-center">
                <b-col>
                    <b-form-checkbox v-model="data[option].state" v-on:change="() => check(option)"
                        :disabled="disabled[option] || !check_roles([ 'model' ])"
                    >
                        {{ raw_options[option].label }}
                    </b-form-checkbox>
                </b-col>
                <b-col class="capitalization_search-analogues_input">
                    <b-form-input v-model="data[option].period_count"
                        :readonly="!check_roles([ 'model' ]) || disabled[option] || !data[option].state" v-on:input="() => check(option)"
                        :state="raw_options[option].state" :formatter="(value) => formatter(value, option)"
                        :aria-describedby="'filter_period-count_' + option"
                    />    
                    <b-form-invalid-feedback :id="'filter_period-count_' + option" tooltip>
                        {{ raw_options[option].msg }}
                    </b-form-invalid-feedback>
                </b-col>
            </b-row>            
        </template>
        
    </mymodal>
</template>

<script>
import mymodal from '../../../../../../widgets/modal'
import api from '../../../../../../../api'
import variables from '../../../../../../../api/variables'

export default {
    props :
	{
		id : String,
		raw_data : Object,
	},

    components :
    {
        mymodal,
    },

    data()
    {
        return {
            raw_options :
            {
                daily :
                {
                    ...variables.periods.types.daily,
                    state: null,
                    msg: `От 0 (не включительно) до ${variables.periods.types.daily.max}`,
                    check: (value) => api.check_number({ value, accuracy : 0, gt : 0, lte : variables.periods.types.daily.max })
                },
                weekly :
                {
                    ...variables.periods.types.weekly,
                    state: null,
                    msg: `От 0 (не включительно) до ${variables.periods.types.weekly.max}`,
                    check: (value) => api.check_number({ value, accuracy : 0, gt : 0, lte : variables.periods.types.weekly.max })
                },
                monthly :
                {
                    ...variables.periods.types.monthly,
                    state: null,
                    msg: `От 0 (не включительно) до ${variables.periods.types.monthly.max}`,
                    check: (value) => api.check_number({ value, accuracy : 0, gt : 0, lte : variables.periods.types.monthly.max })
                },
                quarterly :
                {
                    ...variables.periods.types.quarterly,
                    state: null,
                    msg: `От 0 (не включительно) до ${variables.periods.types.quarterly.max}`,
                    check: (value) => api.check_number({ value, accuracy : 0, gt : 0, lte : variables.periods.types.quarterly.max })
                },
                annually :
                {
                    ...variables.periods.types.annually,
                    state: null,
                    msg: `Равен ${variables.periods.types.annually.max}`,
                    min: variables.periods.types.annually.max,
                    check: (value) => (Number(value) === variables.periods.types.annually.max)
                },
            },

            disabled : {},

            data : null,
        }
    },
    
    computed :
    {
        options()
        {
            return Object.keys(this.raw_options)
        }
    },

    methods :
    {
        check_roles(roles)
        {
            return api.check_roles(this, roles)
        },

        reset()
        {
            this.data = null
            this.options.forEach(key => this.raw_options[key].state = null)
            
        },

        formatter(value, option)
        {
            if (value === "")
            {
                return value
            }
            else if (this.raw_options[option].check(value))
            {
                return Number(value)
            }
            else
            {
                return this.data[option].period_count
            }
        },

		check(option)
		{
			var state = true

            if (this.data) {
                Object.entries(this.data).forEach(([ key, elem ]) => {
                    state = state && (
                        ( elem.state && elem.period_count != null && elem.period_count != "" && this.raw_options[key].check(Number(this.data[key].period_count)))
                        || ( ! elem.state )
                    )
                } )

                if (this.options.includes(option))
                {
                    if (this.data[option].state)
                    {
                        this.raw_options[option].state = this.data[option].period_count != null
                            && this.data[option].period_count != ""
                            && this.raw_options[option].check(Number(this.data[option].period_count))
                    }
                    else
                    {
                        this.raw_options[option].state = null
                        this.data[option].period_count = null
                    }
                }
            }

			return state
		},
        
		execute(query)
		{
			var _query = JSON.parse(api.deep_clone(query))

			// TODO Удаляем фильтр по периодам - костыль, но иначе надо вытаскивать get_query из elements в analogues.vue, что делать совсем не хочется
			if(_query.and)
				_query.and.forEach(
					desc =>
					{
						if(desc.additional_query && desc.additional_query["$or"])
							delete desc.additional_query["$or"]
					})

			_query = JSON.stringify(_query)

			api.call(this, "cadastral_analogues", "get_unique_values_for_field", { field : "current_version.attrs.period", query : _query },
				response =>
				{
					var disabled = {}

					Object.entries(this.raw_options).forEach(
						([ key, value ]) =>
						{
							disabled[key] = ( response.data.findIndex(_value => value.label == _value) < 0 )
						})

					this.disabled = disabled
					
					this.$refs.modal.execute()

                    this.data = api.deep_clone(this.raw_data)
				})
		},

        submit()
        {
            if (this.check_roles([ 'model' ]))
            {
                Object.values(this.data).forEach(
                    elem =>
                    {
                        if(elem.period_count == "" || elem.period_count == null)
                            delete elem.period_count
                    })

                if (!Object.entries(this.data).find(([ key, elem ]) => elem.state && !this.raw_options[key].check(elem.period_count)))
                {
                    api.call_long_operation(this, "Расчет потенциальной арендной платы объектов-аналогов", "cadastral_cost_evaluation", "evaluate_rent_price", { id : this.id, new_filter : this.data },
                        response =>
                        {
                            api.open_response_url(response)
        
                            this.$emit("need_refresh")
                        })
                }
            }
        }
    }
}
</script>

<style>
.capitalization_search-analogues_input
{
    position: relative;
}

.capitalization_search-analogues_input .invalid-tooltip
{
    display: none;
    top: 1.625rem;
    left: unset;
    right: 1.4375rem;
    background-color: var(--bft-neutral-900-tooltip);
    max-width: max-content;
}

.capitalization_search-analogues_input .form-control.is-invalid:hover + .invalid-tooltip
{
    display: block;
}
</style>
